(function () {
  "use strict";

  var OFFSET_TIMESTAMP = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})$/;
  function parseInstant(value) {
    if (typeof value !== "string" || !OFFSET_TIMESTAMP.test(value)) return null;
    var instant = Date.parse(value);
    return Number.isFinite(instant) ? instant : null;
  }
  function state(now, startAt, endAt) {
    var start = parseInstant(startAt);
    var end = parseInstant(endAt);
    if (start === null || end === null || start >= end) return "invalid";
    if (now < start) return "before";
    if (now >= end) return "expired";
    return "active";
  }
  function pad(value) { return String(value).padStart(2, "0"); }
  function setText(root, selector, value) {
    var target = root.querySelector(selector);
    if (target) target.textContent = value;
  }
  function renderSection(section) {
    var storeKey = section.dataset.storeKey;
    var preview = section.dataset.preview === "true";
    var list = section.querySelector("[data-promo-events-list]");
    var empty = section.querySelector("[data-promo-events-empty]");
    if (!list) return;

    var cards = Array.prototype.slice.call(list.querySelectorAll("[data-promo-event]"));
    cards.sort(function (a, b) {
      return (parseInstant(a.dataset.endAt) || Infinity) - (parseInstant(b.dataset.endAt) || Infinity) ||
        String(a.dataset.eventId).localeCompare(String(b.dataset.eventId));
    });
    cards.forEach(function (card) { list.appendChild(card); });

    function render() {
      var now = Date.now();
      var shown = 0;
      cards.forEach(function (card) {
        var currentState = state(now, card.dataset.startAt, card.dataset.endAt);
        var eventPromo = card.dataset.campaignType === "Event Promo";
        var approved = card.dataset.plannerStatus === "approved";
        var publicVisibility = card.dataset.visibility === "public_when_active";
        var verified = card.dataset.offerStatus === "active";
        var verifiedDiscountId = /^gid:\/\/shopify\/DiscountAutomaticNode\/\d+$/.test(card.dataset.discountId || "");
        var expiryCoupled = card.dataset.discountEndAt === card.dataset.endAt;
        var validScope = ["product", "products", "collection"].includes(card.dataset.scopeType) && Boolean(card.dataset.scopeReference);
        var sameStore = card.dataset.storeKey === storeKey;
        var visible = sameStore && eventPromo && currentState === "active" && approved && publicVisibility && verified && verifiedDiscountId && expiryCoupled && validScope;
        var previewVisible = preview && sameStore && eventPromo && currentState !== "invalid";
        card.hidden = !(visible || previewVisible);
        if (card.hidden) return;
        shown += 1;
        var end = parseInstant(card.dataset.endAt);
        var total = Math.max(0, Math.floor((end - now) / 1000));
        setText(card, "[data-days]", String(Math.floor(total / 86400)));
        setText(card, "[data-hours]", pad(Math.floor((total % 86400) / 3600)));
        setText(card, "[data-minutes]", pad(Math.floor((total % 3600) / 60)));
        setText(card, "[data-seconds]", pad(total % 60));
        var badge = card.querySelector("[data-preview-badge]");
        if (badge) badge.hidden = !preview || (visible && currentState === "active");
      });
      if (empty) empty.hidden = shown !== 0;
    }

    render();
    var timer = window.setInterval(render, 1000);
    section.addEventListener("shopify:section:unload", function () { window.clearInterval(timer); }, { once: true });
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-promo-events-page]").forEach(renderSection);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(document); });
  else boot(document);
  document.addEventListener("shopify:section:load", function (event) { boot(event.target); });
}());
